import { api } from './client';
import type {
  CreateAnyWorkoutRequest,
  Exercise,
  Workout,
  WorkoutModality,
  WorkoutPage,
  WorkoutStats,
} from '@/types/Workout';

export const workoutApi = {
  list: (page: number, size: number, modality?: WorkoutModality) => {
    const params = new URLSearchParams({ page: String(page), size: String(size) });
    if (modality) params.set('modality', modality);
    return api<WorkoutPage>(`/api/workouts?${params}`);
  },
  create: (body: CreateAnyWorkoutRequest) =>
    api<Workout>('/api/workouts', {
      method: 'POST',
      body: JSON.stringify(body),
    }),
  remove: (id: string) =>
    api<void>(`/api/workouts/${encodeURIComponent(id)}`, {
      method: 'DELETE',
    }),
  stats: () => api<WorkoutStats[]>('/api/workouts/stats'),
  exercises: () => api<Exercise[]>('/api/workouts/exercises'),
};
